import { render, staticRenderFns } from "./working-reply-refer-form.vue?vue&type=template&id=64b63602&"
import script from "./working-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./working-reply-refer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports